document.addEventListener("DOMContentLoaded", function() {
    // Wait a moment to make sure elements are loaded
    setTimeout(function() {
        const subtotalElement = document.querySelector('.cart__subtotal, .subtotal-line');
        const totalElement = document.querySelector('.cart__total, .total-line');
        const shippingElement = document.querySelector('.cart__shipping, .shipping-line');
        
        if (subtotalElement) subtotalElement.style.display = 'none';
        if (totalElement) totalElement.style.display = 'none';
        if (shippingElement) shippingElement.style.display = 'none';
    }, 500);  // Adjust this delay if necessary
});

class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
